ACC.approval = {

  submitApprovalDecision: function(currentNode) {
    var desictionCode = currentNode.data('decision');

    currentNode.parent().find('#approverSelectedDecision').attr('value', desictionCode);
    currentNode.parents('#approvalDecisionForm').submit();
  },
  submitApprovalDecisionajax: function($obj) {
    var orderapprovaldecision = '.ph-orderapprovaldecision',
        orderNumber = $obj.siblings('input[name*=\'orderCode\']').attr('value'),
        approverSelectedDecision = $obj.attr('data-decision'),
        workflowActionCode = $obj.siblings('#workFlowActionCode').attr('value'),
        comments = $obj.parents(orderapprovaldecision).find('.ph-orderhistory__comments').val(),
        csToken = $('input[name*=\'CSRFToken\']').attr('value'),
        accorHeight = $obj.parents(orderapprovaldecision).height();

    $obj.parents(orderapprovaldecision).height(accorHeight);

    var displayNoneClass = 'ph-d-none',
        $panelTitleNode = $obj.parents(orderapprovaldecision).find('.ph-orderhistory_paneltitle');

    $('.ph-approvedmsg').addClass(displayNoneClass);
    $('.ph-rejectmsg').addClass(displayNoneClass);

    if (approverSelectedDecision === 'APPROVE') {
      $('.ph-approvedmsg').removeClass(displayNoneClass);
      $('#approvedmsg').html('#' + orderNumber);
    } else {
      $('.ph-rejectmsg').removeClass(displayNoneClass);
      $('#rejectedmsg').html('#' + orderNumber);
    }

    $.ajax({
      type: 'GET',
      url: ACC.config.contextPath + '/my-account/getOrdersData.json',
      dataType: 'json',
      async: false,
      data: {
        orderCode: orderNumber,
        approverSelectedDecision: approverSelectedDecision,
        workFlowActionCode: workflowActionCode,
        comments: comments,
        CSRFToken: csToken


      },
      success: function() {
        $('html, body').animate({
          scrollTop: $panelTitleNode.offset().top - 50
        }, 500, function() {
          $obj.parents(orderapprovaldecision).addClass('ph-hiddingeffect');
          $panelTitleNode.html($('.ph-approverglobalmsg_wrapper').html()).attr('class', 'ph-col-12 ph-p-0');

          $obj.parents(orderapprovaldecision).find('.ph-approvalmsg__closebtn').on('click keypress', function() {
            $obj.parents(orderapprovaldecision).remove();
          });

          setTimeout(function() {
            $obj.parents(orderapprovaldecision).remove();
          }, 5000);
        });
      }
    });
  },

  bindToApproverDecisionButton: function() {
    $(document).on('click', '.approverDecisionButton', function(e) {
      if ($(this).data('decision') === 'REJECT') {
        var commentInfo = $('.emptycommentlabel').text(),
            commentSec = $(this).parent().parent();

        if (commentSec.find('.ph-orderhistory__comments').val().trim().length === 0) {
          commentSec.find('.ph-ERROR').remove();
          commentSec.find('.ph-orderhistory_approver').append('<div class="ph-col-md-12 ph-col-sm-12 ph-float-left ph-ERROR">' + commentInfo + '</div>');
          e.preventDefault();
        } else {
          commentSec.find('.ph-ERROR').remove();
          ACC.approval.submitApprovalDecisionajax($(this));
        }
      } else if ($(this).data('decision') === 'REORDER') {
        var reorderAction = $.trim($('.ph-reorderurl').html());


        $(this).parents('#approvalDecisionForm').attr('action', reorderAction).attr('method', 'POST');
        ACC.approval.submitApprovalDecision($(this));
      } else {
        ACC.approval.submitApprovalDecisionajax($(this));
      }
    });
  }
};


$(document).ready(function() {
  ACC.approval.bindToApproverDecisionButton();
});
